
// rounting
import List from './list/index.vue';

export default [
  {
    path: 'list',
    name: 'List',
    component: List,
    meta: {
      title: '持股卡查询',
      breadCrumbShowIndexArr: [0]  // 面包屑
    }
  }
];
